export class LoadCategories {
  static readonly type = '[Accounting] Load Categories';
  constructor() { }
}

export class AddCategory {
  static readonly type = '[Accounting] Add Category';
  constructor(public readonly category: string) { }
}

export class OrderCategory {
  static readonly type = '[Accounting] Order Category';
  constructor(public readonly category: any, public previousIndex: number, public currentIndex: number) { }
}

export class LoadTransactions {
  static readonly type = '[Accounting] Load Transactions';
  constructor() { }
}


export class UpdateSelection {
  static readonly type = '[Accounting] Update Selection';
  constructor(public selection: any[]) { }
}

// UI Actions

export class ConfigureContractorPayroll {
  static readonly type = '[Accounting] Configure Contractor Payroll';
  constructor(public makePayment?: boolean, public contractor?: any) { }
}

export class MakeContractorPayment {
  static readonly type = '[Accounting] Make Contractor Payment';
  constructor(public contractor?: any) { }
}


export class EnterContractorPayment {
  static readonly type = '[Accounting] Enter Contractor Payment';
  constructor(public contractor?: any) { }
}

export class ContractorPaymentRecorded {
  static readonly type = '[Accounting] Contractor Payment Recorded';
  constructor() { }
}
